import { BulkImportMeta } from '@reporting/interfaces/bulk-import-meta-data.interface';

export const BULK_IMPORT_META_DATA: BulkImportMeta[] = [
    {
        routerLink: 'time-off-importers/time-off-requests',
        name: 'reporting.data-import.reportMeta.timeOffRequests.name',
        description: 'reporting.data-import.reportMeta.timeOffRequests.description',
        guide: 'reporting.data-import.reportMeta.timeOffRequests.guide',
        templateLocation: 'download-import-time-off-request-template',
        importEndpoint: 'import-time-off-requests',
        importerName: 'requests',
        successMessage: 'reporting.data-import.processingFileYoullReceiveSummary',
    },
    {
        routerLink: 'time-off-importers/time-off-balance',
        name: 'reporting.data-import.reportMeta.timeOffBalances.name',
        description: 'reporting.data-import.reportMeta.timeOffBalances.description',
        guide: 'reporting.data-import.reportMeta.timeOffBalances.guide',
        templateLocation: 'download-import-balances-template',
        importEndpoint: 'import-balances',
        importerName: 'balances',
    },
    {
        routerLink: 'time-off-importers/time-off-adjustment',
        name: 'reporting.data-import.reportMeta.timeOffAdjustments.name',
        description: 'reporting.data-import.reportMeta.timeOffAdjustments.description',
        guide: 'reporting.data-import.reportMeta.timeOffAdjustments.guide',
        templateLocation: 'download-import-adjustments-template',
        importEndpoint: 'import-adjustments',
        importerName: 'adjustments',
    },
];
